import * as angular from 'angular';

"use strict";

angular.module('DetectInactivityModule', [])

export default 'DetectInactivityModule';